import { inject } from '@angular/core';
import type {
  ActivatedRouteSnapshot,
  CanActivateFn,
  RouterStateSnapshot,
} from '@angular/router';
import { Auth } from '@freelancer/auth';
import { Location } from '@freelancer/location';
import { map } from 'rxjs/operators';

export const RedirectToDashboardGuard = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
): ReturnType<CanActivateFn> => {
  const auth = inject(Auth);
  const location = inject(Location);

  return auth.isLoggedIn().pipe(
    map(isLoggedIn => {
      if (isLoggedIn) {
        return location.createUrlTree(['/dashboard']);
      }
      return true;
    }),
  );
};
